var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"procedures",on:{"click":_vm.openProcedures}},[_c('img',{attrs:{"src":_vm.proceduresImg}}),_c('div',[_vm._v("操作手册")])])
}
var staticRenderFns = []

export { render, staticRenderFns }